<template>
	<div>
		<template v-for="(objAddr, addr_index) in value">
		<h5 :class="[{'mt-3':addr_index>0}]">АДРЕС {{strAddrType(objAddr.address_typeId)}}</h5>
		<div class="row ReClientAddress">
			<label class="col-form-label col-md-12" >Выберите страну</label>
			<div class="col-md-12 d-flex" style="align-items: center;">
				<el-select
					class="w-100 select-primary overflow-overlay"
					size="large"
					placeholder="Выберите страну"
					v-model="objAddr.countryId"
				>
					<el-option
						v-for="(el_opt, el_index) in masCountrys"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
				</el-select>
			</div>

			<template v-if="isRF(objAddr)">
				<label class="col-form-label col-md-12" >Выберите регион</label>
				<div class="col-md-12 d-flex" style="align-items: center;">
					<el-select
						class="w-100 select-primary overflow-overlay"
						size="large"
						filterable
						placeholder="Выберите регион"
						v-model="objAddr.regioncode"
						v-on:change="OnRegionChange"
					>
						<el-option
							v-for="(el_opt, el_index) in masRegions"
							class="select-primary"
							:value="el_opt.value"
							:label="el_opt.label"
							:key="el_index"
						>
						</el-option>
					</el-select>
				</div>
			</template>

			<label class="col-form-label col-md-12"  v-if="isShown">
				<el-tooltip content="Пример заполнения адреса: г Санкт-Петербург пр-кт Культуры дом 11 строение А. Ввводить без точек и запятых" placement="top"><div class="d-inline-block">Введите адрес</div></el-tooltip> 
				<div class="d-inline-block ml-3">
					<base-checkbox :checked="value_dopParams[addr_index].isAddrNotInBase" v-model="value_dopParams[addr_index].isAddrNotInBase">Адрес не найден в базе</base-checkbox>
				</div>
			</label>
			<div v-if="isShown && !value_dopParams[addr_index].isAddrNotInBase" class="col-md-12">
				<div class="d-flex">
					<ReInputSearchDrop 
						class="w-100 pr-0 pl-1"
						placeholder="Введите адрес"
						v-model="objAddr.address"
						:objApiMethod="addrObjApiMethod"
						:strApiMethodKey="strApiMethodKey"
						:strType="strType"
						v-on:change="OnAjaxListSearch"
					/>
					<div class="btnGroup col pr-0 pl-1">
							<button class="btn btn-icon btn-simple btn-danger mt-0" @click="clearAddr(addr_index)">
								<i class="tim-icons icon-trash-simple"></i>
							</button>
					</div>
				</div>
			</div>
			<div v-else class="col-md-12 d-flex">
				<div class="form-group col-md-12 pr-0 pl-1">
					<div class="mb-0">
						<input type="text" placeholder="Введите адрес" class="form-control" v-model.lazy="objAddr.address.inputText">
					</div>
				</div>
				<div class="btnGroup col pr-0 pl-1">
						<button class="btn btn-icon btn-simple btn-danger mt-0" @click="clearAddr(addr_index)">
							<i class="tim-icons icon-trash-simple"></i>
						</button>
				</div>
			</div>

			<label class="col-form-label col-md-12" >Номер квартиры(офиса)</label>
			<div class="col-md-12">
				<div class="form-group">
					<div class="mb-0">
						<input type="number" placeholder="Введите Номер квартиры(офиса)" class="form-control" v-model.lazy="objAddr.flat_num">
					</div>
				</div>
			</div>
			<!--
			<div class="col-md-12">
				<base-radio v-for="(el_opt, el_index) in masAddrType" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="objAddr.address_typeId" inline>{{el_opt.label}}</base-radio>
			</div>
			-->
			<div class="col-md-12 mt-2" v-if="!objAddr.hideButton && addr_index+1 === value.length && value.length < 2">
				<button class="btn btn-simple btn-primary" @click="addEmptyAddr()">
					Адрес по прописке не совпадает с фактическим адресом
				</button>
			</div>
		</div>
		</template>
	</div>
</template>

<script>
	import { Select, Option, Tooltip } from 'element-ui';
	import { BaseCheckbox, /*BaseRadio,*/ } from 'src/components/index';
	import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';

	export default {
		name: 'ReClientAddress',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			[Tooltip.name]: Tooltip,
			BaseCheckbox,
			ReInputSearchDrop,
			// BaseRadio
		},
		props: {
			value: {
				type: Array,
				default: function(){return [
					{
						countryId:'1',
						regioncode: '78',
						address_typeId: '1',
						hideButton:false,
						// regionname: 'г Санкт-Петербург',
						flat_num:'',
						address: {
							inputText:'',
							selectedVal:'',
							ad4_id:'',
							ad4_name:'',
							ad4_short:'',
							ad5_id:'',
							ad5_name:'',
							ad5_short:'',
							ad6_id:'',
							ad6_name:'',
							ad6_short:'',
							ad7_id:'',
							ad7_name:'',
							ad7_short:'',
							ad8_id:'',
							ad8_name:'',
							ad8_short:'',
							regioncode: '78',
							// regionname: 'г Санкт-Петербург',
							text: '',
							text_addr: '',
							value: '',
							manual_addr:'',
						}
					},
				]}
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			clientType: {
				type: String,
				default: 'fiz',
			},
		},
		data () {
			return {
				ver: 1,
				masRegions:[{value: '78', label: 'г Санкт-Петербург',}],
				masCountrys:[{value: '1', label: 'Россия',}],
				// isAddrNotInBase: false,
				addrObjApiMethod:{'obj':'address' ,'flt':{'addr':'','regioncode':(typeof this.value[0].regioncode != 'undefined'?this.value[0].regioncode:'')}},
				strApiMethodKey:'addr',
				strType:'address.addr',
				value_dopParams:[{isAddrNotInBase:false}],
				isShown: false,
			}
		},
		watch:{
			
		},
		computed: {
			masAddrType(){
				if(this.clientType==='fiz') return [{name: '1', label: 'Адрес по прописке',},{name: '2', label: 'Адрес фактический',}];
				return [{name: '3', label: 'Юридический адрес',},{name: '4', label: 'Фактический адрес',}];
			},
		},
		methods: {
			clearAddr(addr_index){
				let dmp_address_typeId = this.value[addr_index].address_typeId;
				this.value_dopParams[addr_index].isAddrNotInBase=false;
				this.$set(this.value, addr_index, {
					countryId:'1',
					regioncode: '78',
					address_typeId: dmp_address_typeId,
					flat_num:'',
					address: {
						inputText:'',
						selectedVal:'',
						ad4_id:'',
						ad4_name:'',
						ad4_short:'',
						ad5_id:'',
						ad5_name:'',
						ad5_short:'',
						ad6_id:'',
						ad6_name:'',
						ad6_short:'',
						ad7_id:'',
						ad7_name:'',
						ad7_short:'',
						ad8_id:'',
						ad8_name:'',
						ad8_short:'',
						regioncode: '78',
						text: '',
						text_addr: '',
						value: '',
						manual_addr:'',
					}
				});
			},
			strAddrType(address_typeId){
				return this.isRegAddr(address_typeId)?'ПО ПРОПИСКЕ':'ФАКТИЧЕСКИЙ';
			},
			OnAjaxListSearch(opt){
				//console.log(opt);
			},
			OnRegionChange(val, objAddr){
				this.addrObjApiMethod.flt.regioncode = val;
				// console.log(typeof this.addrObjApiMethod.flt.regioncode);
				// for (let i = 0; i < this.masRegions.length; i++) {
				// 	if(this.masRegions[i].value==val)
				// 		// objAddr.address.regionname = this.masRegions[i].label;
				// 		this.value.address.regionname = this.masRegions[i].label;
				// }

			},
			isRF(objAddr){
				// console.log("typeof objAddr.regioncode is " + typeof objAddr.regioncode);
				// console.log("typeof objAddr.countryId is " + typeof objAddr.countryId);
				if(objAddr.countryId == '1') return true;
				return false;
			},
			addEmptyAddr(){
				this.value.push(
					{
						countryId:'1',
						regioncode: '78',
						address_typeId: this.masAddrType[1].name,
						flat_num:'',
						address: {
							inputText:'',
							selectedVal:'',
							ad4_id:'',
							ad4_name:'',
							ad4_short:'',
							ad5_id:'',
							ad5_name:'',
							ad5_short:'',
							ad6_id:'',
							ad6_name:'',
							ad6_short:'',
							ad7_id:'',
							ad7_name:'',
							ad7_short:'',
							ad8_id:'',
							ad8_name:'',
							ad8_short:'',
							regioncode: '78',
							text: '',
							text_addr: '',
							value: '',
							manual_addr:'',
						}
					}
				);
				this.value_dopParams.push({isAddrNotInBase:false});
			},
			isRegAddr(address_typeId){
				/* address_typeId - cat_address_type
				+----+-----------------------------------+
				| id | name                              |
				+----+-----------------------------------+
				|  1 | Адрес по прописке                 |физ
				|  2 | Адрес фактический                 |физ
				|  3 | Юридический адрес                 |юр
				|  4 | Фактический адрес                 |юр
				+----+-----------------------------------+
				*/
				if(address_typeId=='1'||address_typeId=='3') {return true;} else {return false;}	
			}
		},
		mounted() {
			this.value_dopParams = [];
			for (let i = 0; i < this.value.length; i++) {
				this.value_dopParams.push({isAddrNotInBase:false});	
				this.isShown = true;					
			}

			this.$GVO.LoadCatPromise('CAT_REGION')
				.then((objApi) => {
					//console.log(objApi);
					if(objApi=== true){
						this.masRegions = [];
						for (let i = 0; i < this.$GVO.cats.CAT_REGION.length; i++) {
							const element = this.$GVO.unlinkObject(this.$GVO.cats.CAT_REGION[i]);
							this.masRegions.push({value: element.regioncode, label: element.name});
								
						}
						// console.log(this.masRegions);
						//console.log('arrdr',this.value);
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			this.$GVO.LoadCatPromise('cat_country')
				.then((objApi) => {
					//console.log(objApi);
					if(objApi=== true){
						this.masCountrys = [];
						for (let i = 0; i < this.$GVO.cats.cat_country.length; i++) {
							const element = this.$GVO.unlinkObject(this.$GVO.cats.cat_country[i]);
							this.masCountrys.push({value: element.id.toString(), label: element.name});
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
		},
	}
</script>
<style scoped>
	.overlay {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 99;
	}
	
</style>
